import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route, RouteComponentProps } from "react-router-dom";

import { PATHS } from "App/router";
import { isUserAuthenticatedSelector } from "Auth/state";
import { isVenueDomain } from "shared/utils";
import { StringParam, useQueryParams } from "use-query-params";

interface AuthRouteProps {
  component: React.ComponentType<any>;
}

/*
  This component redirects the user when they are authenticated.
  If the user came from a private route before authenticating they are redirected back to that route,
  otherwise, they are redirected to the dashboard page.
*/
export const AuthRoute: React.FC<AuthRouteProps> = ({
  component: Component,
  ...rest
}) => {
  const isUserAuthenticated = useSelector(isUserAuthenticatedSelector);

  const [query] = useQueryParams({
    destination: StringParam,
  });

  return (
    <Route
      {...rest}
      render={(props: RouteComponentProps<any, any, any>) =>
        isUserAuthenticated ? (
          <Redirect
            to={
              (query?.destination && decodeURIComponent(query?.destination)) ||
              props.location?.state?.from ||
              (isVenueDomain ? PATHS.DASHBOARD : PATHS.HOME)
            }
          />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};
